import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import UnfoldMore from '@mui/icons-material/UnfoldMore';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

import { Tooltip } from 'uikit/tooltips';

import styles from '../styles/uikitButtonsSortButton.module.scss';

const SortButton = ({
  onClick = () => {},
  sort = 'unsorted',
  isDisabled = false,
  ariaLabels = {},
  disabledMessage = '',
}) => {
  const validatedSort = ['unsorted', 'asc', 'desc'].includes(sort) ? sort : 'unsorted';

  const getNewSort = () => {
    if (validatedSort === 'asc') {
      return 'desc';
    }
    return 'asc';
  };
  const handleClick = () => {
    onClick(getNewSort());
  };

  const SORT_STATES = {
    icon: {
      unsorted: <UnfoldMore />,
      asc: <KeyboardArrowUp />,
      desc: <KeyboardArrowDown />,
    },
    colorClass: {
      unsorted: styles.isPrimary,
      asc: styles.isBrand,
      desc: styles.isBrand,
    },
    ariaLabel: {
      unsorted: i18n.t('aria-sort-unsorted', 'Sort column ascending'),
      asc: i18n.t('aria-sort-asc', 'Column sorted ascending; sort column descending'),
      desc: i18n.t('aria-sort-desc', 'Column sorted descending; sort column ascending'),
    },
  };

  const buttonEl = (
    <button
      type="button"
      className={classnames(styles.element, {
        [SORT_STATES.colorClass[validatedSort]]: validatedSort,
      })}
      aria-label={ariaLabels[validatedSort] || SORT_STATES.ariaLabel[validatedSort]}
      aria-disabled={isDisabled}
      aria-pressed={validatedSort === 'asc' || validatedSort === 'desc'}
      onClick={isDisabled ? null : handleClick}
      data-testid={`sort-button-${validatedSort}`}
    >
      {SORT_STATES.icon[validatedSort]}
    </button>
  );

  if (disabledMessage && isDisabled) {
    return <Tooltip content={disabledMessage}>{buttonEl}</Tooltip>;
  }
  return buttonEl;
};

SortButton.propTypes = {
  onClick: PropTypes.func,
  sort: PropTypes.oneOf(['unsorted', 'asc', 'desc']),
  isDisabled: PropTypes.bool,
  ariaLabels: PropTypes.shape({
    unsorted: PropTypes.string,
    asc: PropTypes.string,
    desc: PropTypes.string,
  }),
  disabledMessage: PropTypes.string,
};

export default SortButton;
